// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Axios Imports
import axios from 'axios'
import { getWhatsappChatDetail, getAllDashboard } from '/src/@api/dashboard'
import { generateMockData } from 'src/utils'
import { addDeviceSwitchReset } from 'src/store/apps/deviceSwitchHandlers'
import { selectDeviceRequestKey } from 'src/store/apps/Common'

// ** Fetch User Profile

const createInitialState = () => ({
  userMessengerId: '',
  userMessengerIdList: '',
  leftTotalCount: 0,
  rightTotalCount: 0,
  members: [],
  selectedMessage: {
    contact: {},
    selected: []
  },
  list: [],
  preViewImage: {
    open: false,
    url: ''
  },
  flag: false,
  advanced: true,
  fetchLoading: true,
  leftPage: 0,
  rightPage: 1,
  summaryPending: false,
  deviceRequestKey: '',
  activeSummaryRequestId: '',
  activeDetailRequestId: '',
  activeUserRequestId: ''
})

// SUMMARY
const fetchUserProfileRequest = createAsyncThunk('Messenger/fetchUserProfile', async ({ page, requestKey }) => {
  // userinfo
  let username =
    JSON.parse(localStorage.getItem('DeviceUser')) != null
      ? JSON.parse(localStorage.getItem('DeviceUser')).username
      : ''

  let deviceUdid =
    JSON.parse(localStorage.getItem('currentDevice')) != null
      ? JSON.parse(localStorage.getItem('currentDevice'))['Unique Identifier']
      : ''

  try {
    let firstData = []
    let members = []

    const response = await getAllDashboard({
      username,
      params: {
        category: 'FACEBOOK_MESSENGER_SUMMARY',
        offset: (page - 1) * 50,
        limit: 50,
        deviceUdid: deviceUdid
      }
    })

    let advanced = username == null || !('advanced' in response) || ['true', true].includes(response?.advanced) // 高级服务开通状态

    if (Array.isArray(response.data.contents) && response.data.contents.length > 0) {
      let userId = response.data.contents.length > 0 ? response.data.contents[0].uid : ''

      let rid =
        response.data.contents.length && response.data.contents[0].sessions != null
          ? response.data.contents[0].sessions[0].chatid
          : ''

      if (page === 1) {
        // 如果是群组需要获取成员
        if (
          response.data.contents != null &&
          response.data.contents[0].sessions !== null &&
          response.data.contents[0].sessions[0].isGroupChat === 1
        ) {
          let getMembers = await getAllDashboard({
            username,
            params: {
              category: 'FACEBOOK_MESSENGER_GROUP_MEMBERS',
              offset: 0,
              limit: 2000,
              deviceUdid: deviceUdid,
              userID: userId,
              rid: rid
            }
          })

          members = getMembers.data.contents ?? []
        }

        let defaultSelectData = await getAllDashboard({
          username,

          params: {
            category: 'FACEBOOK_MESSENGER_DETAIL',
            offset: 0,
            limit: 50,
            deviceUdid: deviceUdid,
            userID: userId,
            rid: rid
          }
        })

        if (defaultSelectData.data.contents !== null) firstData = [...defaultSelectData.data.contents.reverse()]
      }

      if (response.data.contents[0].sessions != null) {
        response.data.contents[0].sessions[0].userMessengerId = userId

        if (!advanced) { // 未开通高级服务
          response.data.contents[0].sessions = generateMockData(response.data.contents[0].sessions).map((item, index) => {
            if (index === 0) return item

            return { ...item, chatid: index }
          })
        }
      }

      let userMessengerIdList =
        response.data.contents == null
          ? []
          : response.data.contents.map(row => {
            return {
              value: row.uid,
              label: (
                <div>
                  <span
                    style={{
                      display: 'inline-block',
                      width: '26px',
                      height: '26px',
                      background: '#ccc',
                      borderRadius: '50%',
                      lineHeight: '26px',
                      textAlign: 'center',
                      fontWeight: '700',
                      marginRight: '10px'
                    }}
                  >
                    {(row.name + row.uid).substring(0, 1)}
                  </span>
                  {row.name}
                </div>
              )
            }
          })

      return {
        data:
          response.data.contents != null && response.data.contents[0].sessions != null
            ? response.data.contents[0].sessions
            : [],
        defaultSelectData: firstData,
        leftPage: page,
        leftTotalCount: response.data.contents != null ? response.data.contents[0].totalCount : 0,
        userMessengerId: response.data.contents != null ? response.data.contents[0].uid : '',
        userMessengerIdList: userMessengerIdList,
        members,
        advanced,
        requestKey
      }
    }

    return {
      data: [],
      defaultSelectData: [],
      leftPage: 0,
      leftTotalCount: 0,
      userMessengerId: '',
      userMessengerIdList: [],
      members: [],
      advanced,
      requestKey
    }
  } catch (error) {
    throw error
  }
})

export const fetchUserProfile = () => (dispatch, getState) => {
  const state = getState()
  const current = state.Messenger
  if (current.summaryPending) return Promise.resolve()

  // 已拉完全部会话，避免触底反复请求
  if (current.leftPage > 0 && current.leftTotalCount > 0 && current.list.length >= current.leftTotalCount) {
    return Promise.resolve()
  }

  const requestKey = selectDeviceRequestKey(state)

  return dispatch(fetchUserProfileRequest({
    page: current.leftPage + 1,
    requestKey
  })).then(action => {
    const latest = getState()
    if (
      fetchUserProfileRequest.fulfilled.match(action) &&
      action.payload.leftPage === 1 &&
      selectDeviceRequestKey(latest) === requestKey &&
      latest.Messenger.activeSummaryRequestId === action.meta.requestId
    ) {
      localStorage.setItem('MessengerItem', JSON.stringify(action.payload.data[0] ?? ''))
      localStorage.setItem('userMessengerIdList', JSON.stringify(action.payload.userMessengerIdList))
    }

    return action
  })
}

// 切换用户
const switchUserRequest = createAsyncThunk('Messenger/switchUser', async ({ userId, requestKey }) => {
  // userinfo
  let username =
    JSON.parse(localStorage.getItem('DeviceUser')) != null
      ? JSON.parse(localStorage.getItem('DeviceUser')).username
      : ''

  let deviceUdid =
    JSON.parse(localStorage.getItem('currentDevice')) != null
      ? JSON.parse(localStorage.getItem('currentDevice'))['Unique Identifier']
      : ''

  let currentIndex = JSON.parse(localStorage.getItem('userMessengerIdList') || '[]').findIndex(row => row.value == userId)

  const response = await getAllDashboard({
    username: username,
    params: {
      category: 'FACEBOOK_MESSENGER_SUMMARY',
      offset: 0,
      limit: 50,
      deviceUdid: deviceUdid
    }
  })

  let defaultSelectData = await getAllDashboard({
    username: username,
    params: {
      category: 'FACEBOOK_MESSENGER_DETAIL',
      offset: 0,
      limit: 50,
      deviceUdid: deviceUdid,
      userID: userId,
      rid: response.data.contents.length > 0 ? response.data.contents[currentIndex].sessions[0].chatid : ''
    }
  })

  let selected = response.data.contents.find(row => row.uid == userId)

  return {
    leftTotalCount: selected.totalCount,
    uid: selected.uid,
    data: selected.sessions == null ? [] : selected.sessions,
    defaultSelectData: defaultSelectData.data.contents == null ? [] : defaultSelectData.data.contents.reverse(),
    rightTotalCount: defaultSelectData.data.totalCount,
    requestKey
  }
})

export const switchUser = userId => (dispatch, getState) => {
  const state = getState()

  return dispatch(switchUserRequest({ userId, requestKey: selectDeviceRequestKey(state) }))
}

// ** Select Message

const selectChatRequest = createAsyncThunk(
  'Messenger/selectChat',
  async ({ contact, page, requestKey }) => {
  // userinfo
  let username =
    JSON.parse(localStorage.getItem('DeviceUser')) != null
      ? JSON.parse(localStorage.getItem('DeviceUser')).username
      : ''

  let deviceUdid =
    JSON.parse(localStorage.getItem('currentDevice')) != null
      ? JSON.parse(localStorage.getItem('currentDevice'))['Unique Identifier']
      : ''

  const PK = contact.chatid

  // 如果是群组需要获取成员

  let members = []
  if (contact.isGroupChat === 1) {
    let getMembers = await getAllDashboard({
      username: username,
      params: {
        category: 'FACEBOOK_MESSENGER_GROUP_MEMBERS',
        offset: 0,
        limit: 2000,
        deviceUdid: deviceUdid,
        userID: contact.userMessengerId,
        rid: PK
      }
    })

    members = getMembers.data.contents ?? []
  }

  let response = await getAllDashboard({
    username: username,
    params: {
      category: 'FACEBOOK_MESSENGER_DETAIL',
      offset: (page - 1) * 50,
      limit: 50,
      deviceUdid: deviceUdid,
      userID: contact.userMessengerId,
      rid: PK
    }
  })

  return {
    contact,
    selected: response.data.contents == null ? [] : response.data.contents.reverse(),
    rightTotalCount: response.data.totalCount,
    members,
    page,
    requestKey
  }
  }
)

export const selectChat = obj => (dispatch, getState) => {
  const state = getState()
  const current = state.Messenger
  let contact = obj || current.selectedMessage.contact
  if (!contact?.chatid) contact = JSON.parse(localStorage.getItem('MessengerItem') || '{}')
  if (!contact?.chatid) return Promise.resolve()

  return dispatch(selectChatRequest({
    contact,
    page: obj ? 1 : current.rightPage + 1,
    requestKey: selectDeviceRequestKey(state)
  }))
}

export const setPerViewImage = createAsyncThunk('Messenger/setPerView', async (obj, { dispatch }) => {
  return obj
})

export const loadingStatus = createAsyncThunk('Messenger/loadingStatus', async (obj, { dispatch }) => {
  return true
})

export const appChatSlice = createSlice({
  name: 'Messenger',
  initialState: createInitialState(),
  reducers: {
    removeSelectedChat: state => {
      state.selectedChat = null
    }
  },
  extraReducers: builder => {
    addDeviceSwitchReset(builder, createInitialState)

    builder.addCase(switchUserRequest.pending, (state, action) => {
      state.deviceRequestKey = action.meta.arg.requestKey
      state.activeUserRequestId = action.meta.requestId
      state.activeDetailRequestId = ''
    })
    builder.addCase(switchUserRequest.fulfilled, (state, action) => {
      if (
        state.deviceRequestKey !== action.meta.arg.requestKey ||
        state.activeUserRequestId !== action.meta.requestId
      ) return

      state.userMessengerId = action.payload.uid

      state.list = action.payload.data
      state.selectedMessage = {
        contact: action.payload.data.length > 0 ? action.payload.data[0] : {},
        selected: action.payload.defaultSelectData
      }

      state.leftTotalCount = action.payload.leftTotalCount
      state.rightTotalCount = action.payload.rightTotalCount
      state.leftPage = 1
      state.rightPage = 1
    })

    builder.addCase(fetchUserProfileRequest.pending, (state, action) => { // 数据获取中
      // 仅首屏全页 loading；分页用 summaryPending 在列表底部转圈
      if (action.meta.arg.page === 1) {
        state.fetchLoading = true
      }
      state.summaryPending = true
      state.deviceRequestKey = action.meta.arg.requestKey
      state.activeSummaryRequestId = action.meta.requestId
    })

    builder.addCase(fetchUserProfileRequest.fulfilled, (state, action) => {
      if (
        state.deviceRequestKey !== action.meta.arg.requestKey ||
        state.activeSummaryRequestId !== action.meta.requestId
      ) return
      if (typeof action.payload == 'undefined') return
      const advanced = action.payload.advanced === true || action.payload.advanced === 'true'
      if (advanced && action.payload.leftPage === 1) {
        state.list = [...action.payload.data]
      } else if (advanced) {
        state.list = [...state.list, ...action.payload.data]
      } else {
        state.list = [...action.payload.data]
      }
      state.leftPage = advanced ? action.payload.leftPage : 0

      state.userMessengerId = action.payload.userMessengerId

      state.userMessengerIdList = action.payload.userMessengerIdList

      if (
        advanced &&
        action.payload.leftPage > 1 &&
        (!action.payload.data || action.payload.data.length === 0)
      ) {
        state.leftTotalCount = state.list.length
      } else {
        state.leftTotalCount = action.payload.leftTotalCount
      }

      if (action.payload.leftPage == 1) {
        state.selectedMessage = {
          contact: action.payload.data.length > 0 ? action.payload.data[0] : {},
          selected: action.payload.defaultSelectData
        }
      }
      state.members = action.payload.members
      state.advanced = advanced
      state.fetchLoading = false
      state.summaryPending = false
    })
    builder.addCase(fetchUserProfileRequest.rejected, (state, action) => {
      if (
        state.deviceRequestKey === action.meta.arg.requestKey &&
        state.activeSummaryRequestId === action.meta.requestId
      ) {
        state.fetchLoading = false
        state.summaryPending = false
      }
    })

    builder.addCase(selectChatRequest.pending, (state, action) => {
      state.deviceRequestKey = action.meta.arg.requestKey
      state.activeDetailRequestId = action.meta.requestId
      state.activeUserRequestId = ''
    })
    builder.addCase(selectChatRequest.fulfilled, (state, action) => {
      if (
        state.deviceRequestKey !== action.meta.arg.requestKey ||
        state.activeDetailRequestId !== action.meta.requestId
      ) return
      state.members = action.payload.members

      if (action.payload.page > 1 && state.selectedMessage.contact.chatid == action.payload.contact.chatid) {
        state.selectedMessage.selected = [...state.selectedMessage.selected, ...action.payload.selected]
      } else {
        state.selectedMessage.selected = action.payload.selected
      }

      state.selectedMessage.contact = action.payload.contact

      state.rightTotalCount = action.payload.rightTotalCount
      state.rightPage = action.payload.page

      state.flag = false
    })

    builder.addCase(setPerViewImage.fulfilled, (state, action) => {
      state.preViewImage = action.payload
    })

    builder.addCase(loadingStatus.fulfilled, (state, action) => {
      state.flag = true
    })
  }
})

export const { removeSelectedChat } = appChatSlice.actions

export default appChatSlice.reducer
